import React, { useEffect, useState } from "react";
import api from "../../../api";
import { useParams, useNavigate } from "react-router-dom";

export default function AssignCaseStudies() {
  const { practiceSetId } = useParams();
  const nav = useNavigate();

  const [caseStudies, setCaseStudies] = useState([]);
  const [selected, setSelected] = useState([]);
  const [requiredCount, setRequiredCount] = useState(0);
  const [loading, setLoading] = useState(true);

  // --------------------------------
  // LOAD CASE STUDIES
  // --------------------------------
  useEffect(() => {
    api
      .get(`/admin/case-study-practice/${practiceSetId}/available-case-studies`)
      .then(res => {
        setCaseStudies(res.data || []);
        setRequiredCount(res.data.length); // or fixed number later
      })
      .catch(() => alert("Failed to load case studies"))
      .finally(() => setLoading(false));
  }, [practiceSetId]);

  // --------------------------------
  // TOGGLE SELECT
  // --------------------------------
  const toggle = (id) => {
    setSelected(prev =>
      prev.includes(id)
        ? prev.filter(x => x !== id)
        : [...prev, id]
    );
  };

  // --------------------------------
  // SAVE
  // --------------------------------
  const save = async () => {
    if (selected.length === 0) {
      alert("Select at least one case study");
      return;
    }

    await api.post(
      `/admin/case-study-practice/${practiceSetId}/assign`,
      { case_study_ids: selected }
    );

    alert("✅ Case Studies Assigned");
    nav("/admin/case-study-practice");
  };

  if (loading) return <p style={{ padding: 20 }}>Loading...</p>;

  return (
    <div style={{ padding: 24 }}>
      <h3>📘 Assign Case Studies</h3>

      {caseStudies.map(cs => (
        <div key={cs.id} style={card}>
          <label>
            <input
              type="checkbox"
              checked={selected.includes(cs.id)}
              onChange={() => toggle(cs.id)}
            />
            <strong style={{ marginLeft: 8 }}>{cs.title}</strong>
          </label>

          <p style={{ marginTop: 8, color: "#475569" }}>
            {cs.preview}...
          </p>
        </div>
      ))}

      <button
        disabled={selected.length === 0}
        onClick={save}
        style={{
          ...btn,
          opacity: selected.length === 0 ? 0.5 : 1
        }}
      >
        Save Case Studies
      </button>
    </div>
  );
}

const card = {
  padding: 16,
  marginBottom: 12,
  borderRadius: 12,
  background: "#fff",
  border: "1px solid #e2e8f0"
};

const btn = {
  marginTop: 20,
  padding: "12px 24px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer"
};
